let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2XK1P")).then(() => parcelRequire('3yjQJ'));